import { ReducerBuilder } from './reducerBuilder';
import { CustomerContactDetailsState } from 'acscp/store';
import { CustomerContactDetailsRequest } from 'acscp/api/requests';
import { CustomerContactDetails } from 'acscp/api/models/customerContactDetails';
import { SetAcsOfficeBasedContacts } from 'acscp/actions';

export const customerContactDetailsReducer =
    new ReducerBuilder<CustomerContactDetailsState>({})
        .successfulRequestCase(CustomerContactDetailsRequest, (state, customerDetails: CustomerContactDetails) => ({
            customer: customerDetails,
        }))
        .actionCase(SetAcsOfficeBasedContacts, (state, setAction) => ({
            ...state,
            acsContactTelephoneNumber: setAction.telephoneNumber,
            mainSiteLink: setAction.mainSiteLink,
        }))
        .build();
